var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownShort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_3",
    "data-name": "Lager 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.15 98.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1d1d1b;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.8,98.02c-2.52,0-3.6-1.32-5.04-3.48L.36,46.54c-.36-.6-.36-1.08-.36-1.32,0-1.44,1.08-2.52,2.52-2.52H18.72c3.12,0,4.4,2.43,5.28,3.84,3.49,5.59,4.21,6.14,4.31,4.47V3.24c0-1.8,1.44-3.24,3.24-3.24h17.04c1.8,0,3.24,1.44,3.24,3.24V50.73c.04,1.99,.65,1.69,4.32-4.19,.88-1.41,2.16-3.84,5.28-3.84h16.2c1.44,0,2.52,1.08,2.52,2.52,0,.24,0,.72-.36,1.32l-32.4,48c-1.32,1.97-2.33,3.25-4.42,3.44h0s-.62,.01-.62,.01l-4.55,.03Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownShort);
export default __webpack_public_path__ + "static/media/arrow-down-short.39bfa8219c34bfe696fab518b1c7840b.svg";
export { ForwardRef as ReactComponent };